import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-critical)";

function IconLinkBroken({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill}>
                <path fill-rule="evenodd" d="M6.935 1.038a2.5 2.5 0 1 0-.869 4.924l.493.087a.5.5 0 1 0 .173-.985l-.492-.086a1.5 1.5 0 1 1 .52-2.955l4.925.868a1.5 1.5 0 1 1-.521 2.955l-.492-.087a.5.5 0 1 0-.174.985l.492.087a2.5 2.5 0 0 0 .869-4.924l-4.924-.869zM2.5 13a2.5 2.5 0 0 1 0-5H3a.5.5 0 0 1 0 1h-.5a1.5 1.5 0 1 0 0 3h5a1.5 1.5 0 0 0 0-3H7a.5.5 0 0 1 0-1h.5a2.5 2.5 0 0 1 0 5h-5z"/>
                <rect x="11.5" y="7.5" width="2.5" height="1" rx=".5"/>
                <rect y="6" width="2.5" height="1" rx=".5"/>
                <rect x="11.5" y="9" width="2.5" height="1" rx=".5" transform="rotate(35.556 11.5 9)"/>
                <rect x="1.582" y="3.5" width="2.5" height="1" rx=".5" transform="rotate(35.556 1.582 3.5)"/>
            </g>
        </svg>
    );
}

export default IconLinkBroken;
